<script>
  import { onMount } from 'svelte';
  import viewport from '@/js/utils/useViewportAction.js';
  import responsive from '../../../utils/responsive';
  import StatsItem from './Item.svelte';

  export let newStats;
  let swiperEl, innerWidth;
  let grow = false;

  onMount(() => {
    Object.assign(swiperEl, {
      spaceBetween: 34,
      slidesPerView: 'auto',
    });

    swiperEl.initialize();
  });
</script>

<svelte:window bind:innerWidth />

<div class="stats-wrapper">
  <section class="stats container container--large">
    {#if newStats.desc}
      <p
        class="h5 stats__desc"
        class:grow
        use:viewport
        on:enterViewport={() => (grow = true)}
      >
        {newStats.desc}
      </p>
    {/if}

    <!-- On smaller screens show slider -->
    <swiper-container
      class="stats__items stats-slider"
      bind:this={swiperEl}
      init={false}
    >
      {#if innerWidth < responsive.s}
        {#if newStats.items.length > 0}
          {#each newStats.items as item}
            <swiper-slide class="swiper-slide">
              <StatsItem {item} />
            </swiper-slide>
          {/each}
        {/if}
      {/if}
    </swiper-container>

    <!-- On larger screens show grid -->
    {#if innerWidth > responsive.s}
      <div
        class="stats__items flexbox"
        class:grow
        use:viewport
        on:enterViewport={() => (grow = true)}
      >
        {#if newStats.items.length > 0}
          {#each newStats.items as item}
            <StatsItem {item} />
          {/each}
        {/if}
      </div>
      {#if newStats.link}
        <div class="text-center">
          <a
            class="btn btn-icon btn-main btn-main--dark stats__more-btn"
            href={newStats.link.url}
            class:grow
            use:viewport
            on:enterViewport={() => (grow = true)}
          >
            <span>{newStats.link.text}</span>
            <i class="isax isax-arrow-right-1" />
          </a>
        </div>
      {/if}
    {/if}
  </section>
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .stats-wrapper {
    overflow-x: hidden;
  }
  .stats {
    &__desc {
      max-width: 70rem;
      text-align: center;
      margin: 0 auto;

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    &__items {
      margin-top: 5rem;
      row-gap: 3.4rem;

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    &__more-btn {
      margin: 5rem auto;

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    .swiper-slide {
      width: 21.4rem;
    }
  }

  :global .stats .swiper-horizontal {
    @include resp-max('s') {
      overflow: visible;
    }
  }
</style>
